import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {
  encryptConfigList({ commit }, params) {
    return api.excellent
      .encryptConfigList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_SERVER_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  }
}
